import React from "react";
import Table from "react-bootstrap/Table";
import { Container } from "react-bootstrap";
import "./Fee.css";
import Banner from "../components/Banner";

const Fee = () => {
const rows = [
  { className: "PG", fee: "₹10,200" },
  { className: "LKG", fee: "₹11,340" },
  { className: "UKG", fee: "₹12,120" },
  { className: "I", fee: "₹15,300" },
  { className: "II", fee: "₹15,480" },
  { className: "III", fee: "₹15,720" },
  { className: "IV", fee: "₹16,980" },
  { className: "V", fee: "₹18,840" },
  { className: "VI", fee: "₹19,800" },
  { className: "VII", fee: "₹20,400" },
  { className: "VIII", fee: "₹20,460" },
  { className: "IX", fee: "₹20,700" },
  { className: "X", fee: "₹24,000" },
  { className: "XI", fee: "₹28,700" },
  { className: "XII", fee: "₹35,400" },
];

  return (
    <>
      <Banner
        title="Fee Structure"
        image={require("../assets/parents-guide-img.jpg")}
        breadcrumbs={[
          { label: "HOME", link: "/home" },
          { label: "Fee Structure", link: "/fee-structure" },
        ]}
      />

      <Container className="fee-table-container">
        {/* <div className="fee-top-div">
          <img
            src={require("../assets/ongc-logo1.jpg")}
            alt="School Logo"
          />
        </div> */}

        <h2 className="table-title mt-5">
          Academic Session Fee Structure 2026-27
        </h2>

        <div className="fee-table-scroll">
          <Table className="custom-fee-table">
            <thead>
              <tr>
                <th>S.NO.</th>
                <th>CLASS</th>
                <th>AMOUNT</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{row.className}</td>
                  <td>{row.fee}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>
    </>
  );
};

export default Fee;